import { FC } from "react";
import Header from "Components/Header";
import LeftNavigation from "Components/LeftNavigation";
import styled from "@emotion/styled";
import SummaryTitle from "Components/SummaryTitle";
import Placehorder from "Components/Placeholder";
import { useNavigate } from "react-router-dom";
import UnsoldList from "./UnsoldList";

const Content = styled.div`
  height: calc(100vh - 180px);
  display: flex;
  justify-content: center;
  padding-top: 100px;
`;

const UnsoldContainer = styled.div`
  width: 880px;
`;

const RightPane = styled.div`
  display: flex;
  flex: 1;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const Unsold: FC = () => {
  const navigate = useNavigate();
  const onSearch = (query: string) => {
    navigate(`/search?q=${query}`);
  };
  return (
    <div>
      <Header onSearch={onSearch} />
      <Content>
        <LeftNavigation active="unsold" />
        <UnsoldContainer>
          <SummaryTitle text="Unsold" />
          {
            false && <Placehorder text="You don't have any unsold items at this time." />
          }
          {
            true && <UnsoldList />
          }
        </UnsoldContainer>
        <RightPane />
      </Content>
    </div>
  );
};

export default Unsold;
